import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IProps {
  rootClass?: string
  iconSize?: string
  size?: string
  clickable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseAiButton' },
  __name: 'BaseAiButton',
  props: {
    rootClass: { default: 'rounded-12' },
    iconSize: { default: '24px' },
    size: { default: '40px' },
    clickable: { type: Boolean, default: true }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v5f567f94": (_ctx.size)
}))




return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseAiButton flex flex-center", [__props.rootClass, { 'cursor-pointer': __props.clickable }]])
  }, [
    _createVNode(_component_k_icon, {
      name: "ai-3",
      size: __props.iconSize
    }, null, 8, ["size"])
  ], 2))
}
}

})